import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Homepage } from './Pages/Homepage';
import { Service } from './Pages/Service';
import { Contact } from './Pages/Contact';
import About from './Pages/About';
import { Client } from './Pages/Client';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';
import Layout from './Components/Layout/Layout';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path='/' element={<Homepage />} />
            <Route path='/about' element={<About />} />
            <Route path='/client' element={<Client />} />
            <Route path='/service' element={<Service />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='/privacy' element={<Privacy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
